import request from '@/utils/request'


// 查询商品自动扣减库存脚本列表
export function listStockScript(query) {
  return request({
    url: '/goods/stock/script/list',
    method: 'get',
    params: query
  })
}

// 查询商品自动扣减库存脚本分页
export function pageStockScript(query) {
  return request({
    url: '/goods/stock/script/page',
    method: 'get',
    params: query
  })
}

// 查询商品自动扣减库存脚本详细
export function getStockScript(data) {
  return request({
    url: '/goods/stock/script/detail',
    method: 'get',
    params: data
  })
}

export function getStockScriptByGoodsId(data) {
  return request({
    url: '/goods/stock/script/detail/goodsId',
    method: 'get',
    params: data
  })
}

// 新增商品自动扣减库存脚本
export function addStockScript(data) {
  return request({
    url: '/goods/stock/script/add',
    method: 'post',
    data: data
  })
}

export function stockScriptStatus(data) {
  return request({
    url: '/goods/stock/script/status',
    method: 'post',
    data: data
  })
}


// 修改商品自动扣减库存脚本
export function updateStockScript(data) {
  return request({
    url: '/goods/stock/script/edit',
    method: 'post',
    data: data
  })
}

// 删除商品自动扣减库存脚本
export function delStockScript(data) {
  return request({
    url: '/goods/stock/script/delete',
    method: 'post',
    data: data
  })
}
